mtl.alloy.factory['single-image-mobile-carousel'] = (function($) {
    'use strict';

    return function(element, options) {

        var $slideshow = $(element);
        
        app.breakpoint.when('phone-s phone-l tablet-s', function() {

            var uniquePager = $slideshow.closest('.carousel').next('.mobile-pager').uniqueId();
            var uniquePagerId = '#' + uniquePager.attr('id');

            $slideshow.find('.empty').detach();

            $slideshow.cycle('destroy');

            $('li', $slideshow).each(function() {
                $(this).appendTo($slideshow);
            });

            $('.group', $slideshow).remove();

            $slideshow.cycle({
                fx: "scrollHorz",
                cycleTimeout: "5000",
                carouselFluid: "true",
                swipe: true,
                swipeFx: "scrollHorz",
                carouselVisible: "1",
                slides: "li",
                pager: uniquePagerId,
                dataInit: "single-image-mobile-carousel"
            });

        }, function() {

            if($('.group', $slideshow).length === 0) {

                $slideshow.cycle('stop');
                $slideshow.cycle('destroy');

                var $rowLength = 5;
                var $groupIndex = 0;
                var $groupTemplate = '<div class="group"><ul class="signposts products" data-init="matchheight"></ul></div>';
                $slideshow.append($($groupTemplate));

                $('li', $slideshow).each(function () {
                    var $currentGroup = $('.group:eq(' + $groupIndex + ') ul', $slideshow);

                    if ($('li', $currentGroup).length >= $rowLength) {
                        $slideshow.append($($groupTemplate));
                        $groupIndex++;

                        $currentGroup = $('.group:eq(' + $groupIndex + ') ul', $slideshow);
                    }

                    $(this).appendTo($currentGroup);
                });

                var uniquePager = $slideshow.closest('.carousel').find('.cycle-pager').attr('id');
                
                $slideshow.cycle({
                    fx: "carousel",
                    cycleTimeout: "5000",
                    carouselFluid: "true",
                    carouselVisible: "1",
                    slides: "> .group",
                    pager: "#"+uniquePager,
                    dataInit: "single-image-mobile-carousel"
                });
            }

        });

    };

}(jQuery));
